import { Materia } from './objeto_materias';
import { CuentasBancarias } from './objeto_cuentas_Bancarias';
import {conversionBooleanoJson, conversionFechaJson, conversionNumberJson, conversionStringJson, convertirFechaFirebase} from './utiles_objetos';

// models/Tutor.js
export class Tutor {
  constructor({
    nombrewhatsapp = '',
    nombreCompleto = '',
    numeroWhatsapp = 0,
    carrera = '',
    correogmail = '',
    universidad = '',
    uid = '',
    rol = 'PROSPECTO',
    tokenNotificacion = '',
    ultimaModificacion = 0,
    infoCompletaUsuario = false,
    materias = [],
    cuentas = [],
    activo = true,
    expulsado = false,
    prospectoAprobado = false,
    hojadevida = '',
    formacionAcademica = '',
    tipoDocumento = '',
    identificacionTutor = '',
    archivado = false,
    paisOrigen = '',
    ciudadOrigen = '',
    permisosUsuario = {},
    examenAdmisionTutor = {},
    sancionTutores = [],
    logs = [],
    estaSancionado = false,
    fechaPenalizacionHasta = null,
    fechaCreacionPerfil = new Date(),
    tipoServicios = [],
    experienciaLaboral = [],
    idiomasManejados = [],
    anexos = {},
    fotoPerfil = '',
    nombreEmpresa = '',
    informacionTutor = '',
    tutorVerificado = '',

    //ya viene con la data
    prospectoAprobadoFecha = new Date(),

    //stats - AUTOMATICO
    estadistica = {},

    actualizarTutor = false,
    
  } = {}) {
    this.nombrewhatsapp = nombrewhatsapp;
    this.nombreCompleto = nombreCompleto;
    this.numeroWhatsapp = numeroWhatsapp;
    this.carrera = carrera;
    this.correogmail = correogmail;
    this.universidad = universidad;
    this.uid = uid;
    this.rol = rol;
    this.tokenNotificacion = tokenNotificacion;
    this.ultimaModificacion = ultimaModificacion;
    this.infoCompletaUsuario = infoCompletaUsuario;
    
    // Convertir subclases
    this.materias = materias.map(m => new Materia(m));
    this.cuentas = cuentas.map(c => new CuentasBancarias(c));
    
    this.activo = activo;
    this.expulsado = expulsado;
    this.prospectoAprobado = prospectoAprobado;
    this.hojadevida = hojadevida;
    this.formacionAcademica = formacionAcademica;
    this.tipoDocumento = tipoDocumento;
    this.identificacionTutor = identificacionTutor;
    this.archivado = archivado;
    this.paisOrigen = paisOrigen;
    this.ciudadOrigen = ciudadOrigen;
    
    // Objetos complejos
    this.permisosUsuario = new UsuarioPermiso(permisosUsuario);
    this.examenAdmisionTutor = new ExamenAdmisionNuevoTutor(examenAdmisionTutor);
    
    // Arrays de objetos
    this.sancionTutores = sancionTutores.map(s => new SancionTutor(s));
    this.logs = logs.map(l => new LogTutor(l));
    
    this.estaSancionado = estaSancionado;
    this.fechaPenalizacionHasta = fechaPenalizacionHasta instanceof Date ? 
      fechaPenalizacionHasta : 
      (fechaPenalizacionHasta ? new Date(fechaPenalizacionHasta) : null);
  
    
    this.fechaCreacionPerfil = fechaCreacionPerfil instanceof Date ? 
      fechaCreacionPerfil : 
      new Date(fechaCreacionPerfil);
    
    this.tipoServicios = [...tipoServicios];
    
    this.experienciaLaboral = experienciaLaboral.map(e => new ExperienciaLaboral(e));
    this.idiomasManejados = idiomasManejados.map(i => new IdiomaManejado(i));
    this.anexos = new Anexo(anexos);
    
    this.fotoPerfil = fotoPerfil;
    this.nombreEmpresa = nombreEmpresa;
    this.informacionTutor = informacionTutor;
    this.tutorVerificado = tutorVerificado;

    this.prospectoAprobadoFecha = prospectoAprobadoFecha;

    this.estadistica = estadistica;

    this.actualizarTutor = actualizarTutor;

  }

  // Método para crear un tutor a partir de datos JSON
  static fromJson(json) {

  // Obtenemos y mostramos cada valor en la consola
  const nombrecompletolocal = json['nombre completo'] || '';
  const carrera = json['carrera'] || '';
  const correogmail = json['Correo gmail'] || '';
  const universidad = json['Universidad'] || '';

  const numerowhatsapplocal = json['numero whatsapp'] || 0;

  const hojadevida = json['hojadevida'] || '';
  const formacionAcademica = json['formacionAcademica'] || '';
  const tipoDocumento = json['tipoDocumento'] || '';
  const identificacionTutor = json['identificacionTutor'] || '';
  const paisOrigen = json['paisOrigen'] || '';
  const ciudadOrigen = json['ciudadOrigen'] || '';
  const fotoPerfil = json['fotoPerfil'] || 'https://dufyasesorias.com/wp-content/uploads/2025/12/Gemini_Generated_Image_9mrrsb9mrrsb9mrr.png';

  //Listas
  const materias = Array.isArray(json['materias']) 
  ? json['materias'].map(materiaData => Materia.fromJson(materiaData))
  : [];

    const infoCompletaUsuario = 
    nombrecompletolocal !== '' && 
    carrera !== '' && 
    correogmail !== '' && 
    universidad !== '' && 
    numerowhatsapplocal !== 0 && 
    hojadevida !== '' && 
    formacionAcademica !== '' && 
    tipoDocumento !== '' && 
    identificacionTutor !== '' && 
    paisOrigen !== '' && 
    ciudadOrigen !== '' && 
    fotoPerfil !== '' && 
    materias.length > 0; 

    const cuentas =  Array.isArray(json['cuentas']) 
    ? json['cuentas'].map(cuentasData => CuentasBancarias.fromJson(cuentasData))
    : [];

    const sanciones = Array.isArray(json['sancionTutores']) 
    ? json['sancionTutores'].map(sancionData => SancionTutor.fromJson(sancionData))
    : [];

    const experenciaLaboralocal = Array.isArray(json['experienciaLaboral']) 
    ? json['experienciaLaboral'].map(experenciaData => ExperienciaLaboral.fromJson(experenciaData))
    : [];

    //Array.isArray(json.experienciaLaboral) ? json.experienciaLaboral : []

    
    //fechas
    const fechaCreacion = convertirFechaFirebase(json['fechaCracionPerfil']);

    const prospectoAprobadoFechaLocal = convertirFechaFirebase(json['prospectoAprobadoFecha']);

    //revisar info completa de usuario

    try{

      return new Tutor({
        nombreCompleto: nombrecompletolocal,
        numeroWhatsapp: numerowhatsapplocal,
        carrera: carrera,
        correogmail: correogmail,
        universidad: universidad,
        hojadevida: hojadevida,
        formacionAcademica: formacionAcademica,
        tipoDocumento: tipoDocumento,
        identificacionTutor: identificacionTutor,
        paisOrigen: paisOrigen,
        ciudadOrigen: ciudadOrigen,
        fotoPerfil: fotoPerfil,
  
        //info que no depende del usuario
        nombrewhatsapp: json['nombre Whatsapp'] || '',
        uid: json['uid'] || '',
        rol:json['rol'] || 'PROSPECTO',
        tokenNotificacion: json['tokenNotificacion'] || '',
        ultimaModificacion: json['ultimaModificacion'] || 0,
        activo: json['activo'] ?? true,
        expulsado: json['expulsado'] || false,
        prospectoAprobado: json['prospectoAprobado'] || false,
        archivado: json['archivado'] || false,
        sancionTutores: sanciones,
        logs: Array.isArray(json.logs) ? json.logs : [],
        estaSancionado: json.estaSancionado || false,
        fechaPenalizacionHasta: json.fechaPenalizacionHasta ? new Date(json.fechaPenalizacionHasta) : null,
        fechaCreacionPerfil: fechaCreacion,
        tutorVerificado: json.tutorVerificado || false,
        nombreEmpresa: json.nombreEmpresa || '',
        informacionTutor: json['informacionTutor'] || '',
  
        //calculado
        infoCompletaUsuario: infoCompletaUsuario,
  
        //Listas
        materias: materias,
        cuentas: cuentas,
        examenAdmisionTutor: ExamenAdmisionNuevoTutor.fromJson(json.examenAdmisionTutor || {}),
        tipoServicios: Array.isArray(json.tipoServicios) ? [...json.tipoServicios] : [],
        experienciaLaboral: experenciaLaboralocal,
        idiomasManejados: Array.isArray(json.idiomasManejados) ? json.idiomasManejados : [],
        anexos: json.anexos || {},
  
        //Usuarios colaboradores o admins
        permisosUsuario: json.permisosUsuario || {},
  
        //viene puesta
        prospectoAprobadoFecha: prospectoAprobadoFechaLocal,

        //automatico
        estadistica: json['estadistica'] || '',

        //actualizar tutor
        actualizarTutor: json['actualizarTutor'] || false,

      });
    }
    catch(error){
      console.log("error al obtener tutor fromJson",error);
    }
    
  }

   // Método toJson para tutor
  toJson() {
    return {
      // Usando las claves originales como en fromJson
      'nombre Whatsapp': this.nombreWhatsapp,
      'nombre completo': this.nombreCompleto,
      'numero whatsapp': this.numeroWhatsapp,
      'carrera': this.carrera,
      'Correo gmail': this.correogmail,
      'Universidad': this.universidad,
      'uid': this.uid,
      'rol': this.rol,
      'tokenNotificacion': this.tokenNotificacion,
      'ultimaModificacion': this.ultimaModificacion,
      'infoCompletaUsuario': this.infoCompletaUsuario,
      
      // Convertir arrays de objetos a formato JSON
      'materias': this.materias.map(m => m.toJson ? m.toJson() : m),
      'cuentas': this.cuentas.map(c => c.toJson ? c.toJson() : c),
      
      'activo': this.activo,
      'expulsado': this.expulsado,
      'prospectoAprobado': this.prospectoAprobado,
      'hojadevida': this.hojadevida,
      'formacionAcademica': this.formacionAcademica,
      'tipoDocumento': this.tipoDocumento,
      'identificacionTutor': this.identificacionTutor,
      'archivado': this.archivado,
      'paisOrigen': this.paisOrigen,
      'ciudadOrigen': this.ciudadOrigen,
      
      // Objetos complejos
      'permisosUsuario': this.permisosUsuario.toJson ? this.permisosUsuario.toJson() : this.permisosUsuario,
      'examenAdmisionTutor': this.examenAdmisionTutor.toJson ? this.examenAdmisionTutor.toJson() : this.examenAdmisionTutor,
      
      // Arrays de objetos
      'sancionTutores': this.sancionTutores.map(s => s.toJson ? s.toJson() : s),
      'logs': this.logs.map(l => l.toJson ? l.toJson() : l),
      
      'estaSancionado': this.estaSancionado,
      'fechaPenalizacionHasta': this.fechaPenalizacionHasta,
      
      'fechaCracionPerfil': this.fechaCreacionPerfil, // Nota: "fechaCracionPerfil" como en fromJson
      
      'tipoServicios': [...this.tipoServicios],
      
      'experienciaLaboral': this.experienciaLaboral.map(e => e.toJson ? e.toJson() : e),
      'idiomasManejados': this.idiomasManejados.map(i => i.toJson ? i.toJson() : i),
      'anexos': this.anexos.toJson ? this.anexos.toJson() : this.anexos,
      
      'fotoPerfil': this.fotoPerfil,
      'nombreEmpresa': this.nombreEmpresa,
      'informacionTutor': this.informacionTutor,
      'tutorVerificado': this.tutorVerificado
    };
  }

  //toMap, para solo las cosas que se suben
  toMap() {
    return{
      "nombre Whatsapp":this.nombrewhatsapp,
      "nombre completo":this.nombreCompleto,
      "numero whatsapp":this.numeroWhatsapp,
      "carrera":this.carrera,
      "Correo gmail":this.correogmail,
      "Universidad":this.universidad,
      'uid':this.uid,
      'activo':this.activo,
      'rol' : this.rol,
      'ultimaModificacion' : this.ultimaModificacion,
      'hojadevida' : this.hojadevida,
      'formacionAcademica' : this.formacionAcademica,
       //'examenAdmisionTutor':this.examenAdmisionTutor.toJson ? this.examenAdmisionTutor.toJson() : this.examenAdmisionTutor,
      'tipoDocumento' : this.tipoDocumento,
      "paisOrigen" : this.paisOrigen,
      "ciudadOrigen" : this.ciudadOrigen,
      'fechaCracionPerfil': this.fechaCracionPerfil instanceof Date ? this.fechaCracionPerfil.getTime() : this.fechaCracionPerfil,
      'identificacionTutor' : this.identificacionTutor,
    }
  }

  //info faltante
  toInfoFaltenteMap(){
    return{
      'tipoServicios': [...this.tipoServicios],
      'materias': this.materias.map(m => m.toJson ? m.toJson() : m),
      'experienciaLaboral': this.experienciaLaboral.map(e => e.toJson ? e.toJson() : e),
      'cuentas': this.cuentas.map(c => c.toJson ? c.toJson() : c),
      'hojadevida': this.hojadevida,
      'fotoPerfil': this.fotoPerfil,
    }
  }

  //Update Data
  updateFromJson(updateData){

    if (!updateData || typeof updateData !== 'object') {
      console.warn('updateData debe ser un objeto válido en tutores');
      return;
    }

    Object.keys(updateData).forEach(field => {
      const value = updateData[field];

      console.log("el caso para update from json tutor",field,value);

      switch(field) {

        case 'nombre completo':
          console.log("el caso es nombre completo a convertir",value);
          this.nombreCompleto = conversionStringJson(value, this.nombreCompleto);
          break;

        case 'fotoPerfil':
          this.fotoPerfil = conversionStringJson(value, this.fotoPerfil);
          break;

        case 'carrera':
          this.carrera = conversionStringJson(value, this.carrera);
          break;

        case 'activo':
          this.activo = conversionBooleanoJson(value, this.activo);
          break;

        case 'expulsado':
          this.expulsado = conversionBooleanoJson(value, this.expulsado);
          break;

        case 'identificacionTutor':
          this.identificacionTutor = conversionStringJson(value, this.identificacionTutor);
          break;

        case 'Universidad':
          this.Universidad = conversionStringJson(value, this.Universidad);
          break;

        case 'numero whatsapp':
          this.numeroWhatsapp = conversionNumberJson(value, this.numeroWhatsapp);
          break;

        case 'paisOrigen':
          this.paisOrigen = conversionStringJson(value, this.paisOrigen);
          break;

        case 'materias':
          // Verificamos que el valor entrante sea realmente un Array
          if (Array.isArray(value)) {
            // Recorremos el array y convertimos cada JSON en una instancia de la clase
            this.materias = value.map(materiaData => Materia.fromJson(materiaData));
          } else {
            console.warn('El valor recibido para cuentas no es un array válido');
          }
          break;

        case 'cuentas':
          // Verificamos que el valor entrante sea realmente un Array
          if (Array.isArray(value)) {
            // Recorremos el array y convertimos cada JSON en una instancia de la clase
            this.cuentas = value.map(cuentaData => CuentasBancarias.fromJson(cuentaData));
          } else {
            console.warn('El valor recibido para cuentas no es un array válido');
          }
          break;

        case 'experienciaLaboral':
          // Verificamos que el valor entrante sea realmente un Array
          if (Array.isArray(value)) {
            // Recorremos el array y convertimos cada JSON en una instancia de la clase
            this.experienciaLaboral = value.map(experienciaData => ExperienciaLaboral.fromJson(experienciaData));
          } else {
            console.warn('El valor recibido para cuentas no es un array válido');
          }
          break;

        case 'tipoServicios':
          this.tipoServicios = [...value];
          break;

        case 'ciudadOrigen':
          this.ciudadOrigen = conversionStringJson(value, this.ciudadOrigen);
          break;

        //permisos usuarios
        case 'permisosUsuario.permiso_solicitudes':
          this.permisosUsuario.permiso_solicitudes = conversionBooleanoJson(value, this.permisosUsuario.permiso_solicitudes);
          break;

        case 'permisosUsuario.permisoTesis':
          this.permisosUsuario.permisoTesis = conversionBooleanoJson(value, this.permisosUsuario.permisoTesis);
          break;

        case 'permisosUsuario.permisoProPlataforma':
          this.permisosUsuario.permisoProPlataforma = conversionBooleanoJson(value, this.permisosUsuario.permisoProPlataforma);
          break;

        case 'permisosUsuario.permiso_tutores':
          this.permisosUsuario.permiso_tutores = conversionBooleanoJson(value, this.permisosUsuario.permiso_tutores);
          break;

        case 'permisosUsuario.permiso_estadisticasPlataforma':
          this.permisosUsuario.permiso_estadisticasPlataforma = conversionBooleanoJson(value, this.permisosUsuario.permiso_estadisticasPlataforma);
          break;

        case'permisosUsuario.permiso_contabilidad_central':
          this.permisosUsuario.permiso_contabilidad_central = conversionBooleanoJson(value, this.permisosUsuario.permiso_contabilidad_central);
          break;
        
        case'permisosUsuario.permisoCalendario':
          this.permisosUsuario.permisoCalendario = conversionBooleanoJson(value, this.permisosUsuario.permisoCalendario);
          break;

        case'permisosUsuario.permiso_configuracionGeneral':
          this.permisosUsuario.permiso_configuracionGeneral = conversionBooleanoJson(value, this.permisosUsuario.permiso_configuracionGeneral);
          break;

        case'permisosUsuario.permisoCuentaCobro':
          this.permisosUsuario.permisoCuentaCobro = conversionBooleanoJson(value, this.permisosUsuario.permisoCuentaCobro);
          break;

        case'permisosUsuario.permisoClientes':
          this.permisosUsuario.permisoClientes = conversionBooleanoJson(value, this.permisosUsuario.permisoClientes);
          break;

        case'examenAdmisionTutor.fechaPresentacion':
          this.examenAdmisionTutor.fechaPresentacion = conversionFechaJson(value, this.examenAdmisionTutor.fechaPresentacion);
          break;

        case'actualizarTutor':
          this.actualizarTutor = conversionBooleanoJson(value, this.actualizarTutor);
          break;

        default:
          console.warn(`Campo desconocido en update data de tutores: ${field}`);
          break;
      }

    });

  }

  //el field path es diferente, toca ajustar
  getFieldValue(fieldPath) {
    console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
    
    if (fieldPath.includes('.')) {
      const [objectName, fieldName] = fieldPath.split('.');
      const value = this[objectName]?.[fieldName];
      console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
      return value;
    }

    let classProperty;
    switch(fieldPath) {
      case 'nombre completo':
        classProperty = 'nombreCompleto';
        break;
      case 'numero whatsapp':
        classProperty = 'numeroWhatsapp';
        break;
      default:
        classProperty = fieldPath;
    }
    
    const value = this[classProperty];
    console.log(`📝 Valor directo ${fieldPath}:`, value);
    return value;
  }

}

//Examenes
export class ExamenTutor {
  constructor(data = {}) {
    this.materia = data.materia || '';
    this.examen = data.examen || '';
    this.respuesta = data.respuesta || '';
  }
}
export class ExamenAdmisionNuevoTutor {
 
  constructor({
    fechaPresentacion = new Date(),
    examenes = [], //
    //examen
    //materia
    //pregunta , aca viene la sol del cliente
    
    codigoPrueba = "",
    
    notaExamen = 0,
    fechaGenerado = new Date(),
    fechaCalificacion = new Date(),
    aprobado = false,

    finalizado = false,
    examenIniciado = false,

  } = {}) {
    this.fechaPresentacion = fechaPresentacion;
    this.examenes = examenes;
    this.codigoPrueba = codigoPrueba;
    this.notaExamen = notaExamen;
    this.fechaGenerado = fechaGenerado;
    this.fechaCalificacion = fechaCalificacion;
    this.aprobado = aprobado;

    this.finalizado = finalizado;
    this.examenIniciado = examenIniciado;
  }

  static fromJson(json){
    const fechaInvalida = new Date(2023, 0, 1); 

    const fechaPresentacionLocal = convertirFechaFirebase(json['fechaPresentacion']);
    const fechaGeneradoLocal = convertirFechaFirebase(json['fechaGenerado']);
    const fechaCalificacionLocal = convertirFechaFirebase(json['fechaCalificacion']);

    const examenesLocal = Array.isArray(json['examenes'])
      ? json['examenes'].map(e => new ExamenTutor(e)) // Asume que ExamenTutor se puede instanciar así
      : [];

    //console.log("antes de comparar",fechaInvalida,fechaPresentacionLocal);

    const isExamenIniciado = fechaInvalida.getTime() !== fechaPresentacionLocal.getTime(); 
    //console.log("el examen esta iniciado",isExamenIniciado)

    return new ExamenAdmisionNuevoTutor({
      fechaPresentacion: fechaPresentacionLocal,
      examenes: examenesLocal,
      codigoPrueba: json['codigoPrueba'] ?? '',
     
      notaExamen: json['notaExamen'] ?? 0,
      fechaGenerado: fechaGeneradoLocal,
      fechaCalificacion: fechaCalificacionLocal,
      aprobado: json['finalizado'] ?? false,

      finalizado: json['finalizado'] ?? false,
      examenIniciado: isExamenIniciado,
    })

  }

  
}

//Esto es para admins
export class UsuarioPermiso {
  constructor(data = {}) {
    //permiso solicitudes
    this.permiso_solicitudes = data.permiso_solicitudes || false;
    this.permisoTesis = data.permisoTesis || false;
    this.permisoProPlataforma = data.permisoProPlataforma || false;

    //tutores
    this.permiso_tutores = data.permiso_tutores || false;

    //calendario
    this.permisoCalendario = data.permisoCalendario || false;

    //estadisticas
    this.permiso_estadisticasPlataforma = data.permiso_estadisticasPlataforma || false;
    this.permisoEstadisticasMarketing = data.permisoEstadisticasMarketing || false;

    //contabilidad
    this.permiso_contabilidad_central = data.permiso_contabilidad_central || false;
    this.permisoCostos = data.permisoCostos || false;

    //configuracion
    this.permiso_configuracionGeneral = data.permiso_configuracionGeneral || false;

    //whachat CRM
    this.permisoWhatChat = data.permisoWhatChat || false;

    //cuentas de cobro
    this.permisoCuentaCobro = data.permisoCuentaCobro || false;

    //Nuevos tutores
    this.permisoNuevosTutores = data.permisoNuevosTutores || false;


    //clientes
    this.permisoClientes = data.permisoClientes || false;

    //sistema disciplinario
    this.permisoSaciones = data.permisoSaciones || false;

    //dashboard
    this.permisoDashboard = data.permisoDashboard|| false;
    this.permisoDashboardProUnad = data.permisoDashboardProUnad|| false;
    this.permisoEstadisticasSolicitudes = data.permisoEstadisticasSolicitudes|| false;
    this.permisoEstadisticasContabilidad = data.permisoEstadisticasContabilidad|| false;

  }
}

export class LogTutor {
  constructor(data = {}) {
    this.fechaConexion = data.fechaConexion ? new Date(data.fechaConexion) : new Date();
  }
}

export class SancionTutor {
  constructor(data = {}) {
    this.fechaSancion = data.fechaSancion ? new Date(data.fechaSancion) : new Date();
    this.tipoSancion = data.tipoSancion || '';
    this.motivoSancion = data.motivoSancion || '';
  }

  static fromJson(json){
    return{
      fechaSancion: '',
      tipoSancion: '',
      motivoSancion: '',
    }
  }
}

export class ExperienciaLaboral {
  constructor(data = {}) {
    this.modalidad = data.modalidad || '';
    this.nombrEmpresa = data.nombrEmpresa || '';
    this.trabajandoActualmente = data.trabajandoActualmente || false;
    this.fechaIncio = data.fechaIncio ? new Date(data.fechaIncio) : new Date();
    this.fechaFinal = data.fechaFinal ? new Date(data.fechaFinal) : new Date();
    this.descripcion = data.descripcion || '';
  }

  static fromJson(json){

    const fechaInicioLocal = convertirFechaFirebase(json['fechaIncio']);
    const fechaFinalLocal = convertirFechaFirebase(json['fechaFinal']);

    return new ExperienciaLaboral({
      modalidad: json['modalidad'] || '',
      nombrEmpresa: json['nombrEmpresa'] || '',
      trabajandoActualmente: json['trabajandoActualmente'] || false,
      fechaInicioLocal,
      fechaFinalLocal,
      descripcion: json['descripcion'] || '',
    });
  }

  toJson(){

  }

  toMap(){

  }



}

export class IdiomaManejado {
  constructor(data = {}) {
    this.idioma = data.idioma || '';
    this.nivelIdioma = data.nivelIdioma || '';
  }
}

export class Anexo {
  constructor(data = {}) {
    this.urlHojaDeVida = data.urlHojaDeVida || '';
  }
}